// extracted by mini-css-extract-plugin
module.exports = {"Input":"styles_Input__18MvC","Input_Container":"styles_Input_Container__3fJJf"};